import { gql } from "@apollo/client";

export const CREATE_PERMISSION = gql`
  mutation CreatePermission($permission: CreatePermissionInput!) {
    createPermission(permission: $permission) {
      _id
      name
      description
      notes
      tags
    }
  }
`;

export const UPDATE_PERMISSION = gql`
  mutation UpdatePermission($permission: UpdateDeletePermissionInput!) {
    updatePermission(permission: $permission) {
      _id
      name
      description
      notes
      tags
    }
  }
`;

export const DELETE_PERMISSION = gql`
  mutation DeletePermission($permission: UpdateDeletePermissionInput!) {
    deletePermission(permission: $permission) {
      _id
      name
      description
      notes
      tags
    }
  }
`;

export const DELETE_MANY_PERMISSIONS = gql`
  mutation DeleteManyPermissions($permissions: [UpdateDeletePermissionInput]!) {
    deleteManyPermissions(permissions: $permissions) {
      _id
      name
      description
      notes
      tags
    }
  }
`;
